import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-version-control',
  templateUrl: './version-control.component.html',
  styleUrls: ['./version-control.component.scss']
})
export class VersionControlComponent {

  constructor(
    public dialogRef: MatDialogRef<VersionControlComponent>
  ) { }

  dialogAction(isContinue: boolean) {
		return this.dialogRef.close(isContinue);
  }
}
